import { makeCancellableAPIRequest } from "./index";

const BuildAPI = {
    getAll(params = {}){
        return makeCancellableAPIRequest(
            "GET",
            "/api/builds/",
            {
                params
            }
        )
    },
    putBuild(data = {} ) {
        return makeCancellableAPIRequest(
            "PUT",
            "/api/build",
            {
                data
            }
        )
    },
    getFilters() {
        return makeCancellableAPIRequest(
            "GET",
            "/api/builds-filter"
        )
    },
    getSLAConfig() {
        return makeCancellableAPIRequest(
            "GET",
            "/api/sla/config?configType=JENKINS"
        )
    },
    postSLAConfig(data = {}) {
        return makeCancellableAPIRequest(
            "POST",
            "/api/sla/config",
            {
                data
            }
        )
    },
    putSLAConfig(data ={}) {
        return makeCancellableAPIRequest(
            "PUT",
            "/api/sla/config",
            {
                data
            }
        )
    },
    getSLA() {
        return makeCancellableAPIRequest(
            "GET",
            "/api/sla/config"
        )
    },
    deleteSLA(id) {
        return makeCancellableAPIRequest(
            "DELETE",
            `/api/sla/config/${id}`
        )
    },
}

export default BuildAPI;